/* tslint:disable */
/* eslint-disable */
/**
 * driverRegistration driver-registration-portal api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 *
 * //!!!! WARNING !!!!!!!!
 * //This is an auto generated file.
 * //Changes to this code will be lost if the code is regenerated.
 */
import type { DocumentUploadPreviewTranslationsTextDocumentPoint1 } from './DocumentUploadPreviewTranslationsTextDocumentPoint1';
import type { DocumentUploadPreviewTranslationsTextDocumentPoint2 } from './DocumentUploadPreviewTranslationsTextDocumentPoint2';
import type { DocumentUploadPreviewTranslationsTextDocumentPoint3 } from './DocumentUploadPreviewTranslationsTextDocumentPoint3';

export interface DocumentUploadPreviewTranslationsTextDocument {
    point_1: DocumentUploadPreviewTranslationsTextDocumentPoint1;
    point_2: DocumentUploadPreviewTranslationsTextDocumentPoint2;
    point_3: DocumentUploadPreviewTranslationsTextDocumentPoint3;
}
